import { joinClasses } from 'utils/componentStyles/style.utils';
import '../../assets/weatherMaps.scss';

const WeatherMapSegmentedControl = ({
  ariaLabel,
  options = [],
  value,
  onChange,
  disabled = false,
  fullWidth = true,
  className,
  buttonClassName,
}) => (
  <div
    aria-label={ariaLabel}
    aria-disabled={disabled || undefined}
    className={joinClasses(
      'weather-map-segmented-control btn-group flex-shrink-0',
      fullWidth && 'w-100',
      className,
    )}
    role="group"
  >
    {options.map((option) => {
      const isSelected = option.value === value;

      return (
        <button
          key={option.value}
          type="button"
          aria-pressed={isSelected}
          className={joinClasses(
            'weather-map-segmented-option btn btn-sm',
            buttonClassName,
            option.className,
          )}
          disabled={disabled || option.isDisabled}
          onClick={() => onChange?.(option.value)}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default WeatherMapSegmentedControl;
